import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosInstanceService } from '../services/axiosInstance'
import { apiRoute } from '../util/constant'
import { resetState } from '../slices/formInitialSlice';

export const initialForm = createAsyncThunk(
    'form/initialData',
    async (_, { rejectWithValue }) => {
        try {
            const instance = await AxiosInstanceService.getAxiosInstance();
            const response = await instance.get(`${apiRoute.verificationValues}`)
            return response.data;
        } catch (error) {
            // return custom error message from backend if present
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
);


export const initialBookingForm = createAsyncThunk(
    'form/initialBookingData',
    async (_, { rejectWithValue }) => {
        try {
            const instance = await AxiosInstanceService.getAxiosInstance();
            const response = await instance.get(`${apiRoute.verificationBookingValues}`)
            return response.data;
        } catch (error) {
            // return custom error message from backend if present
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
);



export const initialShipmentForm = createAsyncThunk(
    'form/initialShipmentData',
    async (_, { rejectWithValue }) => {
        try {
            const instance = await AxiosInstanceService.getAxiosInstance();
            const response = await instance.get(`${apiRoute.verificationShipmentValues}`)
            return response.data;
        } catch (error) {
            // return custom error message from backend if present
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
);










export const initialFormWithVehiclesId = (params) => async (dispatch) => {
    const vehicleId =  params.vehicleId ; 
    await await dispatch(resetState());
    if (params.vehicleId === null){
        return await dispatch(initialForm())
    } else {
        await  dispatch(initialForm())
        return await dispatch(getVehicleInfo({vehicleId}))
    }
}



export const makeByVehicleType = createAsyncThunk(
    'form/makeByVehicleType',
    async ({ id }, { rejectWithValue }) => {
        try {
            const instance = await AxiosInstanceService.getAxiosInstance();
            const response = await instance.get(`${apiRoute.makeByVehicleType}${id}`)
            return response.data;
        } catch (error) {
            // return custom error message from backend if present
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
)




export const carModels = createAsyncThunk(
    'form/carModels',
    async ({ id }, { rejectWithValue }) => {
        try {
            const instance = await AxiosInstanceService.getAxiosInstance();
            const response = await instance.get(`${apiRoute.models}${id}`)
            return response.data;
        } catch (error) {
            // return custom error message from backend if present
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
);





export const containers = createAsyncThunk(
    'form/containers',
    async ({ name = '' , bookingId}, { rejectWithValue }) => {
        try {
            const instance = await AxiosInstanceService.getAxiosInstance();

            if (bookingId){

                const response = await instance.get(`${apiRoute.container}${name}&bookingId=${bookingId}`)
                return response.data;

            } else {

                const response = await instance.get(`${apiRoute.container}${name}`)
                return response.data;

            }


        } catch (error) {
            // return custom error message from backend if present
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
);




export const searchDestination = createAsyncThunk(
    'form/destination',
    async ({ name = '' }, { rejectWithValue }) => {
        try {
            const instance = await AxiosInstanceService.getAxiosInstance();
            const response = await instance.get(`${apiRoute.destinationSearch}${name}`)
            return response.data;
        } catch (error) {
            // return custom error message from backend if present
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
);



export const searchPickupTerminal = createAsyncThunk(
    'form/pickupTerminal',
    async ({ name = '' }, { rejectWithValue }) => {
        try {
            const instance = await AxiosInstanceService.getAxiosInstance();
            const response = await instance.get(`${apiRoute.pickupTerminalSearch}${name}`)
            return response.data;
        } catch (error) {
            // return custom error message from backend if present
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
);



export const searchReturnTerminal = createAsyncThunk(
    'form/returnTerminal',
    async ({ name = '' }, { rejectWithValue }) => {
        try {
            const instance = await AxiosInstanceService.getAxiosInstance();
            const response = await instance.get(`${apiRoute.returnTerminalSearch}${name}`)
            return response.data;
        } catch (error) {
            // return custom error message from backend if present
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
);




export const searchBroker = createAsyncThunk(
    'form/Broker',
    async ({ name = '' }, { rejectWithValue }) => {
        try {
            const instance = await AxiosInstanceService.getAxiosInstance();
            const response = await instance.get(`${apiRoute.brokerSearch}${name}`)
            return response.data;
        } catch (error) {
            // return custom error message from backend if present
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
);




export const searchVehicleType = createAsyncThunk(
    'form/vehicleType',
    async ({ name = '' }, { rejectWithValue }) => {
        try {
            const instance = await AxiosInstanceService.getAxiosInstance();
            const response = await instance.get(`${apiRoute.vehicleTypeSearch}${name}`)
            return response.data;
        } catch (error) {
            // return custom error message from backend if present
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
);



export const searchModel = createAsyncThunk(
    'form/model',
    async ({ name = '' }, { rejectWithValue }) => {
        try {
            const instance = await AxiosInstanceService.getAxiosInstance();
            const response = await instance.get(`${apiRoute.modelSearch}${name}`)
            return response.data;
        } catch (error) {
            // return custom error message from backend if present
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
);


export const searchMake = createAsyncThunk(
    'form/make',
    async ({ name = '' }, { rejectWithValue }) => {
        try {
            const instance = await AxiosInstanceService.getAxiosInstance();
            const response = await instance.get(`${apiRoute.makeSearch}${name}`)
            return response.data;
        } catch (error) {
            // return custom error message from backend if present
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
);




export const searchShippingLine = createAsyncThunk(
    'form/shippingLine',
    async ({ name = '' }, { rejectWithValue }) => {
        try {
            const instance = await AxiosInstanceService.getAxiosInstance();
            const response = await instance.get(`${apiRoute.shippingLineSearch}${name}`)
            return response.data;
        } catch (error) {
            // return custom error message from backend if present
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
);






export const searchPortLoading = createAsyncThunk(
    'form/portLoading',
    async ({ name = '' }, { rejectWithValue }) => {
        try {
            const instance = await AxiosInstanceService.getAxiosInstance();
            const response = await instance.get(`${apiRoute.portLoadingSearch}${name}`)
            return response.data;
        } catch (error) {
            // return custom error message from backend if present
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
);





export const searchTransportCompany = createAsyncThunk(
    'form/transportCompany',
    async ({ name = '' }, { rejectWithValue }) => {
        try {
            const instance = await AxiosInstanceService.getAxiosInstance();
            const response = await instance.get(`${apiRoute.transportCompanySearch}${name}`)
            return response.data;
        } catch (error) {
            // return custom error message from backend if present
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
);



export const searchClient = createAsyncThunk(
    'form/client',
    async ({ name = '', extraQueryParams = null }, { rejectWithValue }) => {
        try {



            const instance = await AxiosInstanceService.getAxiosInstance();
            const response = await instance.get(`${apiRoute.client}${name}`, {
                params: extraQueryParams
            })


            const cacheKey = JSON.stringify(extraQueryParams || {});
            return {
                response: response.data,
                cacheKey
            }

        } catch (error) {
            // return custom error message from backend if present
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
);




export const searchConsignee = createAsyncThunk(
  'form/consignee',
  async ({ name = '', extraQueryParams = null }, { rejectWithValue }) => {
    try {
      const instance = await AxiosInstanceService.getAxiosInstance();

      const response = await instance.get(`${apiRoute.consignee}${name}`, {
        params: extraQueryParams
      });

      const cacheKey = JSON.stringify(extraQueryParams || {});

      return {
        response: response.data,
        cacheKey
      };

    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
);







export const searchConsigneeDock = createAsyncThunk(
    'form/consigneeDock',
    async ({ name = '' , extraQueryParams = null }, { rejectWithValue }) => {
        try {
            const instance = await AxiosInstanceService.getAxiosInstance();
            const response = await instance.get(`${apiRoute.consigneeDock}${name}`, {
                params: extraQueryParams
            })
            return response.data;
        } catch (error) {
            // return custom error message from backend if present
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
);





export const searchBooking = createAsyncThunk(
    'form/booking',
    async ({ name = '' }, { rejectWithValue }) => {
        try {
            const instance = await AxiosInstanceService.getAxiosInstance();
            const response = await instance.get(`${apiRoute.booking}${name}`)
            return response.data;
        } catch (error) {
            // return custom error message from backend if present
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
);







export const getVehicleInfo = createAsyncThunk(
    'form/getVehicleInfo',
    async ({ vehicleId }, { rejectWithValue }) => {
        try {
            const instance = await AxiosInstanceService.getAxiosInstance();
            const response = await instance.get(`${apiRoute.getVehicleInfo}${vehicleId}`)
            return response.data;
        } catch (error) {
            // return custom error message from backend if present
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
);

export const addVehicle = createAsyncThunk(
    'form/addVehicle',
    async ({ data , id}, { rejectWithValue }) => {
      
        try {
            const instance = await AxiosInstanceService.getAxiosInstance();

            if (!id) {
           
            const response = await instance.post(`${apiRoute.addVehicle}`,
                data
            )
            return response.data;
            } else {
        
                const response = await instance.put(`${apiRoute.addVehicle}/${id}`, 
                    data
                )
                return response.data;

            }
        } catch (error) {
            // return custom error message from backend if present
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
);





